export default {
  xeroAccount: undefined,
  xeroAccounts: [],
};
